import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class CalendarNotificationService {

  constructor(
    private afs: AngularFirestore,   // Inject Firestore service
  ) {

  }

  getCalendar() {
    return this.afs.collection('businesses/root/calendar').get();
  }

  setCalendar(day: string, not: any) {

    return this.afs.collection('businesses/root/calendar').doc(day).set(not, { merge: true });
  }

  getNotificationByDay(day: string) {
    return this.afs.collection('businesses/root/calendar').doc(day).get();
  }

  getUsersAFS() {
    return this.afs.collection('businesses/root/calendar', ref => ref
      .limit(20)
      .orderBy('cdate', 'desc')
    ).valueChanges();
  }

}
